<template>
    <Head :title="__('List of roles')"/>

    <BreezeDashboardLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ __('List of roles') }}
            </h2>
        </template>

        <notification v-if="success" color="success">
            {{ success }}
        </notification>

        <card-component :title="__('List of roles')" :icon="mdiAccountMultipleOutline" has-table
                        :header-icon="mdiAccountMultiplePlusOutline"
                        :header-text="__('Create :resource', {resource: __('Role').toLowerCase()})"
                        @headerIconClick="$inertia.visit(route('roles.create'))">
            <roles-table :items="roles"/>
        </card-component>
    </BreezeDashboardLayout>
</template>


<script>
import BreezeDashboardLayout from '@/Layouts/Dashboard'
import CardComponent from '@/Components/Dashboard/CardComponent'
import Notification from '@/Components/Dashboard/Notification'
import {Head} from '@inertiajs/inertia-vue3';
import {
    mdiListStatus,
    mdiAccountMultiplePlusOutline,
    mdiAccountMultipleOutline
} from '@mdi/js'
import Field from '@/Components/Dashboard/Field'
import Control from '@/Components/Dashboard/Control'
import CheckRadioPicker from '@/Components/Dashboard/CheckRadioPicker'
import JbButton from '@/Components/Dashboard/JbButton'
import JbButtons from '@/Components/Dashboard/JbButtons'
import RolesTable from "@/Components/Dashboard/RolesTable"

export default {
    components: {
        RolesTable,
        BreezeDashboardLayout,
        Head,
        CardComponent,
        Notification,
        Field,
        Control,
        CheckRadioPicker,
        JbButton,
        JbButtons
    },
    props: {
        success: String,
        roles: Object
    },
    setup() {
        return {
            mdiListStatus,
            mdiAccountMultiplePlusOutline,
            mdiAccountMultipleOutline
        }
    }
}
</script>
